import React, { FC } from "react";
import {
  Modal,
  Typography,
  Button,
  CircularProgress,
  Select,
  MenuItem,
} from "@mui/material";
import {
  StyledModalDiv,
  RowLayout,
  ColLayout,
} from "../../../../util/accordianStyles";
import useAdminCostSelector from "./useAdminCostSelector";

interface AdminCostModalProps {
  open: boolean;
  handleClose: () => void;
  charge: string;
  withMargin: boolean | "";
  chargeLabel: string;
  quoteId: string;
  userId: string;
  isFetching: boolean;
  dealerTax?: number;
}

const AdminCostModal: FC<AdminCostModalProps> = ({
  open,
  handleClose,
  charge,
  withMargin,
  chargeLabel,
  quoteId,
  userId,
  isFetching,
  dealerTax
}) => {
  const {
    preventEnterEffects,
    handleKeyDown,
    handleChange,
    handleCostChange,
    loading,
    value,
    err,
    modalStyle,
    cost,
    addAdminCost
  } = useAdminCostSelector(
    handleClose,
    charge,
    withMargin,
    chargeLabel,
    quoteId,
    userId,
    isFetching,
    dealerTax
  );

  const body = (
    <StyledModalDiv style={modalStyle} onKeyDown={handleKeyDown}>
      <ColLayout>
        <h2>Add a Charge</h2>

        <RowLayout style={{ paddingBottom: 20 }}>
          <input
            name="label"
            placeholder="Type of Charge"
            autoComplete="off"
            value={cost.label}
            onChange={handleCostChange}
            style={{ padding: 5, width: 150, marginRight: 20 }}
            onKeyDown={preventEnterEffects}
          />

          <input
            step="any"
            type="number"
            name="charge"
            autoComplete="off"
            placeholder="Amount of Charge"
            value={cost.charge}
            onChange={handleCostChange}
            style={{ padding: 5, width: 150 }}
            onKeyDown={preventEnterEffects}
          />
        </RowLayout>

        {dealerTax ? null : (
          <ColLayout>
          <Typography
            style={{ color: "black", fontWeight: "bold", paddingBottom: 5 }}
          >
            Include In:
          </Typography>
          <Select
            onChange={handleChange}
            style={{ width: 250 }}
            value={value}
            size="small"
          >
            <MenuItem value=""></MenuItem>
            <MenuItem value="Dealer/Customer Price">
              Dealer/Customer Price
            </MenuItem>
            <MenuItem value="Dealer Price">Dealer Price</MenuItem>
          </Select>
        </ColLayout>
        )}

        {err && (
          <Typography style={{ color: "red", paddingTop: 20 }}>
            {err}
          </Typography>
        )}

        <RowLayout style={{ paddingTop: 20 }}>
          <Button
            onClick={handleClose}
            variant="contained"
            style={{ marginRight: 10 }}
            color="inherit"
          >
            Cancel
          </Button>

          {!loading ? (
            <Button
              onClick={addAdminCost}
              color="primary"
              variant="contained"
              style={{ marginLeft: 10 }}
            >
              Add
            </Button>
          ) : (
            <Button
              color="primary"
              variant="contained"
              style={{ marginLeft: 10 }}
            >
              <CircularProgress style={{ color: "white" }} />
            </Button>
          )}
        </RowLayout>
      </ColLayout>
    </StyledModalDiv>
  );

  return (
    <Modal open={open} onClose={handleClose}>
      {body}
    </Modal>
  );
};

export default AdminCostModal;
